import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
    'inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold tracking-tight transition-colors',
    {
        variants: {
            variant: {
                default: 'bg-blue-50 text-blue-700 border border-blue-200/70',
                secondary: 'bg-slate-100 text-slate-700 border border-slate-200',
                outline: 'border border-slate-300 text-slate-700',
                success: 'bg-emerald-50 text-emerald-700 border border-emerald-200/70',
                warning: 'bg-amber-50 text-amber-700 border border-amber-200/70',
                ghost: 'text-slate-600 hover:bg-slate-100/70',
                dot: 'border border-blue-200/70 bg-blue-50/70 text-blue-700 backdrop-blur-sm pl-2.5',
            },
        },
        defaultVariants: { variant: 'default' },
    }
);

export interface BadgeProps
    extends React.HTMLAttributes<HTMLSpanElement>,
        VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
    return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
